import { useTranslation } from "react-i18next";
import { useRillContext } from "../../../../rill/RillReact/share/base";
import {
  calculateFreeTrialDaysLeft,
  isCoachConverted,
  isCoachFreeTrial,
  isPullActiveCoach,
} from "../../../../utils/user-helpers";
import { getRoleNameById } from "../../../dashboard/settings/manage-coaches/utils/manage-coaches-utils";
import EmailAutomationsPanel from "../automations/EmailAutomationsPanel";
import ExploreEmailCards from "../automations/ExploreEmailCards";
import { CustomWorkflowsList } from "../components/CustomWorkflowsList";
import LearnWorkflowsList from "../components/LearnWorkflowsList";
import { customWorkflowsList } from "../data/customWorkflowsList";

// PUSH and PULL have their own workflows (Getting Started) besides Email Automations
const ownWorkflows = (access) => access === "push" || access === "pull";

const CustomWorkflows = ({
  userCanAccessToPush,
  userOrganizationCanAccessToWorkflows,
}) => {
  const { t } = useTranslation("coaching-portal");
  const { locals } = useRillContext();

  const {
    activeUser,
    organizationOwner,
    organizationRoles,
    query,
    sendingSettings,
    workflows,
  } = locals;
  const roleName = activeUser.organizationRoleId
    ? getRoleNameById(organizationRoles, activeUser.organizationRoleId)
    : "Owner";

  const isCoach =
    activeUser.permissions?.includes("coach") &&
    !(!organizationOwner && !isCoachConverted(activeUser));
  const isExpiredPull =
    isCoachFreeTrial(activeUser) && calculateFreeTrialDaysLeft(activeUser) < 1;
  const userToBindInformation =
    roleName === "Owner" ? activeUser : organizationOwner;

  const filteredWorkflows = workflows.filter((workflow) => {
    return workflow.access === query.access;
  });

  const {
    emailProducts = [],
    automationsList,
    automationFilterOptions,
    automationTemplates,
  } = locals;
  const emailAvailable = emailProducts.length > 0;
  const showingEmail =
    emailProducts.includes(query.access) &&
    (query.view === "email" || !ownWorkflows(query.access));
  const automations =
    automationsList === null || automationsList === undefined
      ? null
      : automationsList.automations.filter(
          (automation) => automation.product === query.access
        );
  const tabLink = (access, label) => (
    <a
      href={`/actions/refresh?access=${access}&view=`}
      aria-current={query.access === access || undefined}
    >
      {label}
    </a>
  );

  return (
    <main className="custom-workflows">
      <header>
        <hgroup className="mobile-hidden">
          <h3>{t("customWorkflows.title")}</h3>
          <p className="p4">{t("customWorkflows.description")}</p>
        </hgroup>
        <nav role="tablist">
          {userCanAccessToPush &&
            userOrganizationCanAccessToWorkflows &&
            tabLink("push", t("customWorkflows.subscriptionsPush"))}
          {!!isCoach &&
            !isExpiredPull &&
            isPullActiveCoach(userToBindInformation) &&
            tabLink("pull", t("customWorkflows.coachingPull"))}
          {emailProducts.includes("press") &&
            tabLink("press", t("emailAutomations.tabs.press"))}
          {emailProducts.includes("perform") &&
            tabLink("perform", t("emailAutomations.tabs.perform"))}
        </nav>
        {/* <ExploreSelector customWorkflowsList={customWorkflowsList} /> */}
      </header>
      <section>
        <LearnWorkflowsList
          customWorkflowsList={
            ownWorkflows(query.access)
              ? customWorkflowsList[query.access] || []
              : []
          }
          workflows={filteredWorkflows}
          access={query.access}
        >
          {emailAvailable && emailProducts.includes(query.access) ? (
            <ExploreEmailCards
              access={query.access}
              showingEmail={showingEmail}
              hasActive={automations?.some(
                (automation) => automation.status === "active"
              )}
              domainVerified={sendingSettings?.state === "verified"}
            />
          ) : null}
        </LearnWorkflowsList>
        {showingEmail ? (
          <EmailAutomationsPanel
            product={query.access}
            automations={automations}
            filterOptions={automationFilterOptions ?? undefined}
            sendingSettings={sendingSettings}
            templateCount={automationTemplates?.templates?.length}
          />
        ) : (
          <CustomWorkflowsList workflows={filteredWorkflows} />
        )}
      </section>
    </main>
  );
};

export default CustomWorkflows;
